export const E1 = [
    "No experiencia",
    "Principiante",
    "Experiencia básica",
    "Con experiencia",
    "Experto"

];

export const E2 = [
    "No experiencia(DEEPSEA, COMAP, DEIF, ETC.)",
    "Principiante(DEEPSEA, COMAP, DEIF, ETC.)",
    "Experiencia básica(DEEPSEA, COMAP, DEIF, ETC.)",
    "Con experiencia(DEEPSEA, COMAP, DEIF, ETC.)",
    "Experto(DEEPSEA, COMAP, DEIF, ETC.)"
];

export const E3 = [
    "No experiencia (BASLER, UNITROL, ETC.)",
    "Principiante (BASLER, UNITROL, ETC.)",
    "Experiencia básica (BASLER, UNITROL, ETC.)",
    "Con experiencia (BASLER, UNITROL, ETC.)",
    "Experto (BASLER, UNITROL, ETC.)"
];

export const E4 = [
    "Si",
    "No",
    "Subcontratar"

];

export const E5 = [
    "Hasta 200 kva",
    "Hasta 500 kva",
    "Hasta 1000 kva",
    "Hasta 1500 kva",
    "Hasta 2000 kva",
    "Hasta 2500 kva",
    "Hasta 3000 kva",
    "Sin límite"
];

export const E6 = [
    "No hay servicio en el sitio",
    "Hasta 500 km",
    "Hasta 1000 km",
    "Más de 1000 km (sin límite)"

];

export const E7 = [
    "Ninguna",
    "Si del 1 al 5",
    "Si de 6 a 10",
    "Si mas de 10"

];

export const E8 = [
    "Si",
    "No"
];

export const E9 = [
    "Si con laser",
    "Sí con comparador",
    "Si con otra herramienta",
    "No"

];
export const E10 = [
    "Si servicio confirmado",
    "No disponible"
];

export const E11 = [
    "Aprobado",
    "No aprobado"
];

export const E12 = [
    "Nulo",
    "Pobre",
    "Básico",
    "Bueno",
    "Excelente"

];

export const E13 = [
    "Service",
    "Meccalte"
];

export const EArea = [
    "Europa - Italia",
    "Europa - España",
    "Europa - Reino Unido / EIRE",
    "Europa - Alemania",
    "Europa - Francia",
    "Europa - Rusia",
    "Europa - Otros países",
    "África",
    "Norteamérica",
    "Centroamérica",
    "Sudamerica",
    "medio este",
    "Lejano Oriente - India",
    "Lejano Oriente"
]


export const ESNotes = [
    "El botón de la derecha llena automáticamente el campo en función de la información enumerada anteriormente. Si no se reconoce esta información, ingrese manualmente las coordenadas, latitud y longitud, separadas por una coma <br> (ejemplo: 45.6515661 , 11.8564252, luego latitud, luego un espacio, luego una coma, luego un espacio y finalmente la longitud).",
    "Personal técnico, ingenieros para intervención en el sitio",
    "Situación subsidiaria, complete un cuestionario SPQ adicional para cada instalación / subsidiaria",
    "Número aproximado de reparaciones de taller e intervenciones in situ realizadas para Mecc Alte",
    "Número de reparaciones de taller e intervenciones in situ realizadas para Mecc Alte en los últimos 12 meses, especifique el período",
    "Tarifa estándar por hora para la actividad del taller",
    "Tarifa estándar por hora para la actividad en el sitio",
    "Auditoría / fecha de visita; especificar visitantes Mecc Alte",
    "Comente sobre posibles competiciones con otros fabricantes de alternadores",
    "Comente sobre posibles competiciones con otros fabricantes de grupos electrógenos",
    "Seleccione el nivel sobre informes exhaustivos y buena actitud de comunicación",
    "Seleccionar estado de aprobación, estado autorizado"
];